import { Outlet } from "react-router-dom";

import { Footer } from "./Footer";
import { Header } from "./Header";

/** Tekdi-branded shell around every page. Pages render their own <main>. */
export function Layout() {
  return (
    <div className="shell">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}
